export const getUserSessionToken = () => {
  const token = localStorage.getItem('user_token');
  if (!token) return null;

  try {
    const userInfo = JSON.parse(localStorage.getItem('user_info') || 'null');
    return userInfo?.user_type === 'User' ? token : null;
  } catch (error) {
    console.warn('Stored user session is invalid; requiring user sign-in.', error);
    return null;
  }
};

export const getAuthenticatedSessionToken = () => (
  localStorage.getItem('user_token') ||
  localStorage.getItem('technician_token') ||
  localStorage.getItem('auth_token')
);
